import React from "react";
import CartContext from "./cart-context";
import { useReducer } from "react";


const defaultCartState = {
    items:[]
}


const cartReducer = (state, action) => {
    // console.log('action.type');
    // console.log(action.type);
    
    if(action.type === 'ADD'){
        const updatedItems = state.items.concat(action.item);
        // console.log("updatedItems------",action.item);
        
        return{
            items:updatedItems
           
        }
        
    } 
    // console.log("action.type------",action.type);
    if(action.type === 'REMOVE'){
        // const existingCartItemIndex = state.item.findIndex(
        //     (item) => item.id === action.id
        // );
        // const existingItem = state.items[existingCartItemIndex]
        // console.log('REMOVE CART ACTION', action.id);
        // console.log('state.items Remove', state.items);
        // console.log('state.items Remove', state.items);
        let updatedItems = state.items.filter(
            item => item.title !== action.id
        )
        // console.log('updatedItems%%%%%%% remove', updatedItems);

        return {
            items:updatedItems
        }
    }
    return defaultCartState;
}

const CartProvider = (props) => {

    const [cartState, dispatchCartAction] = useReducer(cartReducer, defaultCartState)

    const addItemToCartHandler = (event,item) => {
        // console.log(item);
        item = item.cardDetails;
        dispatchCartAction({type:'ADD', item:item});
    };
    const findItemInCartHandler = (item) => {
        // console.log(item);
        
    };
    const removeItemToCartHandler = (event, item) => {
        // console.log('removeItemToCartHandler',item)
        let id=item;
        
        dispatchCartAction({type:'REMOVE', id:id})
    };

    const cartContext = {
        items:cartState.items,
        additem:addItemToCartHandler,
        removeItem:removeItemToCartHandler,
        finditem:findItemInCartHandler,
    }
return <CartContext.Provider value={cartContext}>
{props.children}
</CartContext.Provider>
}

export default CartProvider;